import { Injectable } from '@angular/core';
import { ActionCell } from '@material-library';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppBarActionsService {
  private dataSource = new BehaviorSubject<ActionCell>(null);
  public currentData = this.dataSource.asObservable();

  public updateActions(data: ActionCell): void {
    this.dataSource.next({
      ...data,
      actions: [...(data?.actions || [])],
    });
  }
}
